import { render, staticRenderFns } from "./SigningProgressModal.component.vue?vue&type=template&id=70ac5f64"
import script from "./SigningProgressModal.component.vue?vue&type=script&lang=js"
export * from "./SigningProgressModal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports